<template>
  <div class="container">
    <!-- 头部标题 -->
    <van-nav-bar title="商家入驻"
                 class="title">
      <img slot="left"
           class="img"
           src="@/assets/back.png"
           @click="$router.back()" />
    </van-nav-bar>
    <div class="main">
      <div class="text">商家入驻信息填写</div>
      <div class="btn">
        <van-button type="default"
                    class="active"
                    round>企业入驻</van-button>
        <van-button type="default"
                    @click="$router.push('/business/settlement/personal')"
                    round>个人入驻</van-button>
      </div>
      <h4>1.基本信息</h4>
      <!-- //表单 -->
      <van-form class="form">
        <van-field label="公司名称"
                   placeholder="请填写名称" />
        <van-field label="联系方式"
                   placeholder="请填写联系方式" />
        <van-field label="公司地址"
                   placeholder="请填写具体地址" />
        <h4>2.法人信息</h4>
        <van-field label="姓名"
                   placeholder="请填写姓名" />
        <van-field name="radio"
                   label="性别">
          <template #input>
            <van-radio-group v-model="radio"
                             direction="horizontal">
              <van-radio name="1">男</van-radio>
              <van-radio name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field label="联系方式"
                   placeholder="请填写联系方式" />

        <van-field label="供应商类型"
                   placeholder="请选择"
                   is-link
                   @click="showPopup1"
                   v-model="SupplierType" />

        <van-field label="主营产品"
                   placeholder="请选择"
                   is-link
                   @click="showPopup2"
                   v-model="MainProducts" />
        <van-field label="专营品牌"
                   placeholder="请填写" />

        <div class="jianjie">简介</div>
        <van-field class="textarea"
                   rows="2"
                   autosize
                   type="textarea"
                   maxlength="200"
                   placeholder="请填写 (200字以内)" />
        <h4>
          3.营业执照/代理证书等相应证件
        </h4>
        <van-uploader />
        <van-checkbox class="ckeckbox"
                      v-model="checked">我已阅读并同意平台协议合同内容</van-checkbox>
        <van-button block
                    class="submit"
                    type="default"
                    native-type="submit">
          提交
        </van-button>
      </van-form>
    </div>

    <!-- 供应商类型弹层 -->
    <van-popup v-model="show1"
               position="bottom"
               :style="{ height: '30%' }">
      <van-picker show-toolbar
                  @cancel="show1 = false"
                  @confirm="typeConfirm"
                  :default-index="1"
                  :columns="columns1" />
    </van-popup>
    <!-- 主营产品弹层 -->
    <van-popup v-model="show2"
               position="bottom"
               :style="{ height: '30%' }">
      <van-picker show-toolbar
                  @cancel="show2 = false"
                  @confirm="productsConfirm"
                  :default-index="1"
                  :columns="columns2" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'store',
  data () {
    return {
      radio: '1',
      checked: true,
      SupplierType: '',
      MainProducts: '',
      show1: false,
      show2: false,
      columns1: ['原厂', '高级VIP创客', '代理商'],
      columns2: ['电子', '物料', '其他'],

    }
  },
  methods: {
    showPopup1 () {
      this.show1 = true
    },
    showPopup2 () {
      this.show2 = true
    },
    typeConfirm (e) {
      this.SupplierType = e
      this.show1 = false
    },
    productsConfirm (e) {
      this.MainProducts = e
      this.show2 = false
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .title {
    background-color: #f3f3f3;

    .img {
      width: 21px;
      height: 21px;
    }
  }
  .main {
    padding: 0 12px;
    .text {
      font-size: 26px;
      font-weight: 700;
      margin-top: 21px;
    }
    .btn {
      margin: 10px 38px;
      display: flex;
      justify-content: space-between;
      .van-button {
        width: 118px;
        height: 38px;
        background-color: #eee;
      }
    }
    h4 {
      font-size: 18px;
      margin: 15px 0;
    }
    .form {
      .van-field {
        font-size: 18px;
        padding: 18px 0 10px;
        border-bottom: 1px solid #f3f3f3;
        /deep/.van-radio__icon--checked .van-icon {
          background-color: #fe003b;
          border-color: #fe003b;
        }
        .van-radio--horizontal {
          margin-right: 30px;
        }
      }
      .jianjie {
        margin-top: 30px;
        margin-bottom: 10px;
        font-size: 18px;
      }
      .textarea {
        border: 1px solid #eee;
        padding: 10px;
        height: 244px;
      }
      .ckeckbox {
        margin-top: 20px;
        .van-checkbox__label {
          font-size: 13px;
          color: rgba(93, 98, 130, 1);
        }
      }
      .submit {
        margin: 20px 0;
        background: linear-gradient(
          0deg,
          rgba(244, 4, 66, 1) 0%,
          rgba(226, 23, 75, 0.73) 100%
        );
        border-radius: 4px;
      }
    }
  }
  .active {
    background-color: #feeaee !important;
    color: #fe4670;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/business/settlement/store.vue